module.exports = __webpack_public_path__ + "img/judges.6020ec81.svg";